module.exports = __webpack_public_path__ + "static/img/2827a4f19f4fa527ad05ec6a61297f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv5.png
// module id = wTFD
// module chunks = 1